import type { ClientTransport } from "./netclient.ts";

export interface LinkConditions {
  latencyMs: number; // one-way
  jitterMs: number;
  lossPct: number; // unreliable channel only
}

/** Wraps a transport with simulated one-way latency/jitter/loss in both directions. */
export function withConditions(inner: ClientTransport, c: LinkConditions): ClientTransport {
  const delay = () => Math.max(0, c.latencyMs + (Math.random() * 2 - 1) * c.jitterMs);
  const drop = () => Math.random() * 100 < c.lossPct;
  const outer: ClientTransport = {
    sendReliable: (m) => setTimeout(() => inner.sendReliable(m), c.latencyMs),
    sendUnreliable: (d) => {
      if (!drop()) setTimeout(() => inner.sendUnreliable(d), delay());
    },
    close: () => inner.close(),
  };
  inner.onReliable = (m) => setTimeout(() => outer.onReliable?.(m), c.latencyMs);
  inner.onUnreliable = (d) => {
    if (!drop()) setTimeout(() => outer.onUnreliable?.(d), delay());
  };
  inner.onClose = () => outer.onClose?.();
  return outer;
}
